import { asyncActionType } from "app/utils";

export const GET = asyncActionType("@proposals/GET");
export const QUERY = asyncActionType("@proposals/QUERY");
export const ADD = asyncActionType("@proposals/ADD");
export const UPDATE = asyncActionType("@proposals/UPDATE");
export const DELETE = asyncActionType("@proposals/DELETE");
export const ON_SUBMIT = asyncActionType("@proposals/ON_SUBMIT");
export const GET_PERMISSIONS = asyncActionType("@proposals/PERMISSIONS");

export const API_BASE_URL = "/api/proposal";



// WEBPACK FOOTER //
// ./src/app/proposals/constants.js